import React from "react"

import AllPosts from "../../../features/businessLibrary/containers/AllPosts"
import SideBar from "../../../features/businessLibrary/containers/SideBar"
import TopBar from "../../../features/businessLibrary/containers/TopBar"
import { libraryPostTypes } from "../../../features/userGeneratedContent/lib/postTypes"
import BrowseLibraryLayout from "../../../layouts/BrowseLibraryLayout"

const AllArticles = AllPosts(libraryPostTypes.articles)

const Articles = () => (
  <BrowseLibraryLayout
    sideColumn={SideBar(libraryPostTypes.articles)}
    topRow={TopBar(libraryPostTypes.articles)}
  >
    <AllArticles />
  </BrowseLibraryLayout>
)

export default Articles
